import classNames from "classnames";
import PropTypes from "prop-types";

const YesNoBlock = ({
  question,
  highlight,
  value,
  onChange,
  yesLabel = "Oui",
  noLabel = "Non",
  variant = "pill",
  children,
  className,
}) => {
  const renderQuestion = () => {
    if (!highlight || !question) {
      return question;
    }
    const parts = question.split(highlight);
    if (parts.length === 1) {
      return question;
    }
    return (
      <>
        {parts[0]}
        <strong>{highlight}</strong>
        {parts.slice(1).join(highlight)}
      </>
    );
  };

  return (
    <div
      className={classNames(
        "acoris-yes-no",
        `acoris-yes-no--${variant}`,
        {
          "acoris-yes-no--expanded": Boolean(children),
        },
        className,
      )}
    >
      <div className="acoris-yes-no__header">
        <p className="acoris-yes-no__question">{renderQuestion()}</p>
        <div className="acoris-yes-no__actions">
          <button
            type="button"
            className={classNames("acoris-yes-no__btn", {
              "acoris-yes-no__btn--active": value === true,
            })}
            onClick={() => onChange(true)}
          >
            {yesLabel}
          </button>
          <button
            type="button"
            className={classNames("acoris-yes-no__btn", {
              "acoris-yes-no__btn--active": value === false,
            })}
            onClick={() => onChange(false)}
          >
            {noLabel}
          </button>
        </div>
      </div>
      {children && <div className="acoris-yes-no__body">{children}</div>}
    </div>
  );
};

YesNoBlock.propTypes = {
  question: PropTypes.node.isRequired,
  highlight: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  yesLabel: PropTypes.string,
  noLabel: PropTypes.string,
  variant: PropTypes.oneOf(["pill", "card", "nested"]),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default YesNoBlock;
